import { render, staticRenderFns } from "./ChallengeParentGoalModal.vue?vue&type=template&id=af0f645a&"
import script from "./ChallengeParentGoalModal.vue?vue&type=script&lang=js&"
export * from "./ChallengeParentGoalModal.vue?vue&type=script&lang=js&"
import style0 from "./ChallengeParentGoalModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports